<template>
  <div class="sizes">


    <!-- standaarmaten / maatwerk selectie-->
    <TabSelectorIconFullWidth :tabs="[
      {
        id: '0',
        name: 'Standaardmaten',
        icon: 'vector-square'
      },
      {
        id: '1',
        name: 'Maatwerk',
        icon: 'tape-measure'
      }
    ]" :selectedBerging="selectedSizeMode" @change="changeSelectedSizeMode" v-if="config.maatwerk.enabled && !config.standaardmatenDisabled"/>

    <div v-if="selectedSizes.overstekKlos.enabled && (selectedSizes.overstekKlos.klosVoEditable || selectedSizes.overstekKlos.klosAcEditable || selectedSizes.overstekKlos.klosLiEditable || selectedSizes.overstekKlos.klosReEditable)" class="overstekklos-container">
      <ExpansionCard title="Overstekken" :open="false">
        <div style="padding: 0px 16px">
            <div class="overstek-header">
              <p class="overstek-text">Zet hier uw overstek aan of uit.</p>
                <button v-if="uiSettings[0]?.maatwerkInfobox"
                  class="card-button-specs" 
                  @mouseover="specsBtnMouseOver" 
                  @mouseleave="specsBtnMouseLeave"
                  @click.stop="enableAndHoldSpecs()"
                >
                  <div class="card-question-mark" style="pointer-events: none;">?</div>
                  <h3 class="card-button-specs-text">
                    Meer info
                  </h3>
                </button>
            </div>
    
            <!-- overstekklos voor -->
            <div v-if="selectedSizes.overstekKlos.klosVoEditable && selectedSizes.overstekKlos.klosVoEnabled" class="overstekklos-container-block">
              <input class="checkbox" type="checkbox" id="voEnabled" name="boeideel-checkbox" v-model="overstekConfig.voEnabled">
              <label for="voEnabled" class="checkbox-label sizes-form-checkbox overstekklos-container-checkbox">
                <mdicon
                  name="check-bold"
                  class="checkbox-label-icon"
                  :class="overstekConfig.voEnabled ? 'checkbox-label-icon-active' : ''"
                  size="20"
                />
              </label>
              <h3 class="custom-size-title overstekklos-container-label">Overstek voor</h3>
            </div>
    
            <!-- overstekklos achter -->
            <div v-if="selectedSizes.overstekKlos.klosAcEditable && selectedSizes.overstekKlos.klosAcEnabled" class="overstekklos-container-block">
              <input class="checkbox" type="checkbox" id="acEnabled" name="boeideel-checkbox" v-model="overstekConfig.acEnabled">
              <label for="acEnabled" class="checkbox-label sizes-form-checkbox overstekklos-container-checkbox">
                <mdicon
                    name="check-bold"
                    class="checkbox-label-icon"
                    :class="overstekConfig.acEnabled ? 'checkbox-label-icon-active' : ''"
                    size="20"
                />
              </label>
              <h3 class="custom-size-title overstekklos-container-label">Overstek achter</h3>
            </div>
    
            <!-- overstekklos links -->
            <div v-if="selectedSizes.overstekKlos.klosLiEditable && selectedSizes.overstekKlos.klosLiEnabled" class="overstekklos-container-block">
              <input class="checkbox" type="checkbox" id="liEnabled" name="boeideel-checkbox" v-model="overstekConfig.liEnabled">
              <label for="liEnabled" class="checkbox-label sizes-form-checkbox overstekklos-container-checkbox">
                <mdicon
                    name="check-bold"
                    class="checkbox-label-icon"
                    :class="overstekConfig.liEnabled ? 'checkbox-label-icon-active' : ''"
                    size="20"
                />
              </label>
              <h3 class="custom-size-title overstekklos-container-label">Overstek links</h3>
            </div>
    
            <!-- overstekklos rechts -->
            <div v-if="selectedSizes.overstekKlos.klosReEditable && selectedSizes.overstekKlos.klosReEnabled" class="overstekklos-container-block">
              <input class="checkbox" type="checkbox" id="reEnabled" name="boeideel-checkbox" v-model="overstekConfig.reEnabled">
              <label for="reEnabled" class="checkbox-label sizes-form-checkbox overstekklos-container-checkbox">
                <mdicon
                    name="check-bold"
                    class="checkbox-label-icon"
                    :class="overstekConfig.reEnabled ? 'checkbox-label-icon-active' : ''"
                    size="20"
                />
              </label>
              <h3 class="custom-size-title overstekklos-container-label">Overstek rechts</h3>
            </div>
          </div>
      </ExpansionCard>  
    </div>

    <!--standaardmaten-->
    <div v-if="selectedSizeMode === '0' && !config.standaardmatenDisabled" class="standaardmaten">
      <p class="standaardmaten-text">Maak hier een keuze uit onze standaardafmetingen. Al onze standaardafmetingen zijn scherp geprijsd.<br><br>Wilt u bijvoorbeeld een hoekmodel of een specifieke afmeting die er niet tussen staat? Vermeld dit dan bij de aanvraag, wij werken dit graag verder uit met u.</p>
      
      <!-- <div class="sizes-section">
        <h3>Diepte</h3>

        <TabSelector extension=" mm" :tabs="depths" @change="changeDepth" />


      </div>

      <div class="sizes-section">
        <h3>Breedte</h3>

        <TabSelector extension=" mm" :tabs="widths" @change="changeWidth" />
      </div> -->

      <TabSelectorBergingen :tabs="bergingen" :selectedBerging="selectedBerging" @change="changeBerging" v-if="bergingen.length > 1"/>

        <template v-for="size in sizes" :key="size.diepte">

        
        <div class="sizes-section" v-if="size.breedtes.length" >
          <h3  v-if="size.breedtes.length" class="sizes-section-title">{{config.model}} met een diepte van {{ Math.ceil(getTotalOverhang(size).y / 100) * 100 }}</h3>
          <div class="sizes-grid" >
            <div 
              class="sizes-grid-size" 
              :class="selectedSizes.breedte === breedte.breedte && selectedSizes.diepte === size.diepte && selectedSizes.bergingType === breedte.bergingType  ? 'sizes-grid-size-active' : ''" 
              v-for="breedte in sortBreedte(size.breedtes)" 
              :key="breedte.breedte"  
              @click="changeSize({
                diepte: size.diepte, 
                hoogte: size.hoogtePaal, 
                breedte: breedte.breedte, 
                bergingType: breedte.bergingType,
                artikelNummer: breedte.artikelNummer,
                wallDivision: breedte.wallDivision,
                maximaleMuurBreedte: size.maximaleMuurBreedte,
                staanderDikte: size.staanderDikte, 
                poer: size.poer,
                schoor: size.schoor, 
                ringBalk: size.ringBalk,
                extraRingBalk: size.extraRingBalk,
                ringbalkTussenPaal: size.ringbalkTussenPaal,
                gordingBalk: size.gordingBalk,
                extraBalkOpGording: size.extraBalkOpGording,
                extraPlankAchter: size.extraPlankAchter,
                ringBalkGording: size.ringBalkGording,
                overstekKlos: size.overstekKlos,
                boeideel: size.boeideel,
                trim: size.trim,
                dak: size.dak,
                dakgoot: size.dakgoot,
                wall: size.wall,
                omlijstingPalen: size.omlijstingPalen,
                veranda: size.veranda
              })"
            >
              <div>
                <p>{{ getTotalOverhang(size, breedte).x }} x {{ getTotalOverhang(size, breedte).y }}</p>
                <p class="staander">Staandermaat {{breedte.breedte }} x {{size.diepte}}</p>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>

  
    <div class="diepte-breedte-container" v-if="selectedSizeMode === '1' || config.standaardmatenDisabled">
      <!--  -->
      <div class="custom-size-input-container">
        <span class="custom-size-title">Diepte</span>
        <input 
          type="number"
          v-model.number="depth"
          class="custom-size-input"
          @change="handleCustomInputChange"
          @keydown="validateInputKeys"
        >
        <div class="custom-size-input-after">
          <span class="custom-size-title-range">{{ config.maatwerk.depth.min }}-{{ config.maatwerk.depth.max }}</span>
          <div class="custom-size-input-unit">mm</div>
        </div>
      </div>
      <div class="custom-size-input-container">
        <span class="custom-size-title">Breedte</span>
        <input 
          type="number"
          v-model.number="width"
          class="custom-size-input"
          @change="handleCustomInputChange"
          @keydown="validateInputKeys"
        >
        <div class="custom-size-input-after">
          <span class="custom-size-title-range">{{ config.maatwerk.width.min }}-{{ config.maatwerk.width.max }}</span>
          <div class="custom-size-input-unit">mm</div>
        </div>
      </div>

      <span class="afmetingen-text">*afmetingen invullen op basis van buitenkant staanders</span>
      <img class="afmetingen-image" :src="`${previewsServer}/textures/ui/new/maatwerk.png`">

      <!-- overstekklos toggles -->
      
    </div>



  <Teleport to="body">
    <Transition name="fade">
      <div
        v-show="specsVisible"
        id="fullcover"
        @click="specsVisible = false"
      >              
        <div 
          :class="onMobile ? 'modalspecs modalspecs-size-mobile' : 'modalspecs modalspecs-size'"
          @click.stop=""
        >
            <button 
              class="modalclosebutton" 
              @mouseover="specsCloseBtnMouseOver" 
              @mouseleave="specsCloseBtnMouseLeave"
              @click="specsVisible = false"
            >
              <Transition name="closebtn">
                <div 
                  v-show="hasGlowingCloseBtn"
                  class="absolutepos glowingclose"
                />
              </Transition>
              <div>
                ×
              </div>
            </button>
          <!-- <div class="greyheader"> 
            {{ data.infobox.header }}
          </div> -->
          <div class="imagescroller">
            <img class="modalimage" :src="`/infoboximages/${infoboxes.find(info => info.id === uiSettings[0]?.maatwerkInfobox)?.urlEnding}`" alt="">
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script>
  // import TabSelector from '@/components/inputs/TabSelector';
  import TabSelectorIconFullWidth from '@/components/inputs/TabSelectorIconsFullWidth.vue'
  import TabSelectorBergingen from '@/components/inputs/TabSelectorBergingen.vue'
  import ExpansionCard from '@/components/layout/ExpansionCard.vue'
  import { mapGetters } from 'vuex'

  export default {
    name: "sizes",

    components: {
      TabSelectorBergingen,
      TabSelectorIconFullWidth,
      ExpansionCard
      // TabSelector
    },

    data () {
      return {
        sizes: [],
        bergingen: [],
        selectedBerging: '',
        selectedSizeMode: '0',
        width: 7000,
        depth: 3500,
        previewsServer: import.meta.env.VITE_VUE_APP_PREVIEWS_SERVER,
        overstekConfig: {
          // voEnabled: true,
          // acEnabled: true,
          // liEnabled: true,
          // reEnabled: true,
        },
        uisettings: this.$store.state.cms.menuUISettings,
        specsVisible: false,
        hasGlowingInfoBtn: false,
        hasGlowingCloseBtn: false
      }
    },

    async created() {
      await this.get()
      this.getUISettings()
      this.$store.dispatch('enableMapMode', true)

      /*this.getBergingen.forEach(berging => {
        if() {
          this.bergingen.push(berging)
        }
      })*/
      this.getSizes.forEach(size => {
        size.breedtes.forEach(breedte => {
          const bergingType = this.getBergingen.find(berging => berging.id ===breedte.bergingType)
          if(!this.bergingen.includes(bergingType) && bergingType) {
            this.bergingen.push(bergingType)
          }
        })
      })
      // console.log(this.bergingen)

      this.selectedBerging = this.config.afmetingen.bergingType
      this.sizes = JSON.parse(JSON.stringify(this.getSizes))
      this.sizes.forEach(size => {
        for(let i = size.breedtes.length-1; i > -1; i--) {
          if (size.breedtes[i].bergingType !== this.selectedBerging) {
            size.breedtes.splice(i, 1)
          }
        }
      })

      // console.log("this.config", this.config.afmetingen)

      // check if dimension is standaard
      let foundWidth = null
      for(let i = 0; i < this.sizes.length; i++) {
        if(this.sizes[i].diepte === this.config.afmetingen.diepte) {
          for(let j = 0; j < this.sizes[i].breedtes.length; j++) {
            if(this.sizes[i].breedtes[j].breedte === this.config.afmetingen.breedte) {
              foundWidth = this.sizes[i].breedtes[j]
              break
            }
          }
        }
        if(foundWidth) {
          break
        }
      }
      if (!foundWidth) {
        this.selectedSizeMode = '1'
      }
    },

    methods: {
      changeSize(size) {
        // console.log(size)
        // console.log(this.models, this.selectedSizes, this.modelTypes, this.config)
        this.$store.dispatch('requestSizeChange', {size, mode: 'size', shouldResetWalls: true})
      },

      async get () {
        if (!this.models) {
          await this.$store.dispatch('getAvailableModels')
        }
      },

      changeBerging (berging) {
        this.selectedBerging = berging
        this.sizes = JSON.parse(JSON.stringify(this.getSizes))
        // console.log(this.selectedBerging, this.getSizes)
        this.sizes.forEach(size => {
          for(let i = size.breedtes.length-1; i > -1; i--) {
            if (size.breedtes[i].bergingType !== this.selectedBerging) {
              size.breedtes.splice(i, 1)
            }
          }
        })
      },

      sortBreedte (array) {
        let newArray = [...array]
        newArray.sort((a, b) => {
          return a.breedte - b.breedte;
        })
        return newArray
      },

      changeSelectedSizeMode (mode) {
        this.selectedSizeMode = mode
      },

      handleCustomInputChange () {
        // 1) Bewaak maatwerk-breedte: klem de invoer binnen [min, max]
        if(this.width < this.config.maatwerk.width.min) {
          this.width = this.config.maatwerk.width.min
        } else if(this.width > this.config.maatwerk.width.max) {
          this.width = this.config.maatwerk.width.max
        }

        // 2) Bewaak maatwerk-diepte: klem de invoer binnen [min, max]
        if(this.depth < this.config.maatwerk.depth.min) {
          this.depth = this.config.maatwerk.depth.min
        } else if(this.depth > this.config.maatwerk.depth.max) {
          this.depth = this.config.maatwerk.depth.max
        }
        
        // 3) Diepte-selectie (standaardmaten i.c.m. maatwerk-invoer)
        //    Sorteer beschikbare dieptes oplopend (klein -> groot).
        //    Gebruik een kopie om mutatie door sort() te voorkomen.
        const sortedDepths = [...this.sizes].sort((a, b) => a.diepte - b.diepte)

        //    Kies de eerste standaard diepte die >= de ingevoerde diepte is (kleinste passende = "ceil").
        //    Als er geen match is, val terug op de grootste beschikbare diepte (laatste element).
        const foundDepth = sortedDepths.find(size => size.diepte >= this.depth)
        const higherDepth = foundDepth || sortedDepths[sortedDepths.length - 1]

        // 4) Breedte-selectie: sorteer oplopend en kies de kleinste passende breedte (>= invoer).
        //    Als er geen match is, val terug op de grootste beschikbare breedte.
        const sortedWidths = [...higherDepth.breedtes].sort((a, b) => a.breedte - b.breedte) 
        const higherWidth = sortedWidths.find(breedte => breedte.breedte >= this.width) || sortedWidths[sortedWidths.length - 1]

        // 5) Bepaal de muurverdeling (wallDivision) op basis van totale breedte,
        //    staanderdikte en maximale muurlengte: verdeel de beschikbare ruimte
        //    gelijkmatig over het benodigde aantal muursegmenten.
        const amountOfWalls = Math.ceil((this.width-higherDepth.staanderDikte) / (higherDepth.maximaleMuurBreedte+higherDepth.staanderDikte))
        const wallDivision = []
        for(let i = 0; i < amountOfWalls; i++) {
          wallDivision.push({
            bergingEnabled: false,
            width: (this.width - ((amountOfWalls+1)*higherDepth.staanderDikte))/amountOfWalls
          })
        }

        // 6) Update de configuratie met de gekozen maten en bijbehorende
        //    constructie-eigenschappen van de geselecteerde diepte/breedte.

        this.changeSize({
          diepte: this.depth, 
          hoogte: higherDepth.hoogtePaal, 
          breedte: this.width, 
          bergingType: higherWidth.bergingType,
          artikelNummer: null,
          wallDivision,
          maximaleMuurBreedte: higherDepth.maximaleMuurBreedte,
          staanderDikte: higherDepth.staanderDikte, 
          poer: higherDepth.poer,
          schoor: higherDepth.schoor, 
          ringBalk: higherDepth.ringBalk,
          extraRingBalk: higherDepth.extraRingBalk,
          ringbalkTussenPaal: higherDepth.ringbalkTussenPaal,
          gordingBalk: higherDepth.gordingBalk,
          extraBalkOpGording: higherDepth.extraBalkOpGording,
          extraPlankAchter: higherDepth.extraPlankAchter,
          ringBalkGording: higherDepth.ringBalkGording,
          overstekKlos: higherDepth.overstekKlos,
          boeideel: higherDepth.boeideel,
          trim: higherDepth.trim,
          dak: higherDepth.dak,
          dakgoot: higherDepth.dakgoot,
          wall: higherDepth.wall,
          omlijstingPalen: higherDepth.omlijstingPalen,
          veranda: higherDepth.veranda
        })
      },

      validateInputKeys (e) {
        const allowedKeys = [
          'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
          'Tab', 'Enter', 'Home', 'End'
        ];

        // Allow Ctrl/Command + A (Select All), C (Copy), V (Paste), X (Cut)
        const ctrlCmdKeys = ['a', 'c', 'v', 'x'];
        
        if (allowedKeys.includes(e.key) ||
            (e.ctrlKey || e.metaKey) && ctrlCmdKeys.includes(e.key.toLowerCase())) {
          return; // Allow the key event
        }
        
        // Prevent non-numeric keys
        if (!/^\d$/.test(e.key)) {
          e.preventDefault();
        }
      },

      getTotalOverhang(size, breedte) {
        // Mirror key variables used in 3D (parijs.js) for clarity and future alignment
        const LOG_PREFIX = '[Sizes.vue:getTotalOverhang]'
        
        // Resolve modelType similar to 3D usage (parijs.js)
        const modelTypes = this.modelTypes || []
        const models = this.models || []
        let selectedModelTypeId = this.config?.modelType?.id
          ?? this.config?.modelTypeId
          ?? this.selectedSizes?.modelTypeId
          ?? this.selectedSizes?.modelType?.id
          ?? null
        let modelType = null
        if (selectedModelTypeId != null) {
          modelType = modelTypes.find(t => t?.id === selectedModelTypeId) || null
        }
        if (!modelType) {
          const mtName = this.config?.model || this.config?.modelType?.name || null
          if (mtName) {
            modelType = modelTypes.find(t => t?.name === mtName || t?.label === mtName) || null
          }
        }

        /* eslint-disable no-console */
        // Derive active model and its roof classification (type.name) from models
        let activeModel = null
        if (selectedModelTypeId != null) {
          activeModel = models.find(m => m?.id === selectedModelTypeId || m?._id === selectedModelTypeId) || null
        }
        if (!activeModel) {
          const mName = this.config?.model || null
          if (mName) {
            activeModel = models.find(m => m?.name === mName) || null
          }
        }
        const roofTypeName = activeModel?.type?.name || modelType?.type?.name || null
        const roofTypeId = activeModel?.type?.id || modelType?.type?.id || null

  
        // Overstekklos flags and lengths per side (mm)
        // - li/re/vo/ac: whether the klos (overhang block) is enabled on that side
        // - xBov*: top-length of the klos contributing to overhang when enabled
        const klosLiEnabledRaw = size.overstekKlos?.klosLiEnabled || false
        const klosReEnabledRaw = size.overstekKlos?.klosReEnabled || false
        const klosVoEnabledRaw = size.overstekKlos?.klosVoEnabled || false
        const klosAcEnabledRaw = size.overstekKlos?.klosAcEnabled || false
        const xBovLi = size.overstekKlos?.xBovLi || 0
        const xBovRe = size.overstekKlos?.xBovRe || 0
        const xBovVo = size.overstekKlos?.xBovVo || 0
        const xBovAc = size.overstekKlos?.xBovAc || 0

        // UI overstek toggles (vo/ac/li/re) can disable sides even if the size has them enabled
        // This matches the gating done in 3D before computing totalOverhang
        const oc = this.getOverstekConfig || {}
        const klosLiEnabled = klosLiEnabledRaw && (oc.liEnabled ?? true)
        const klosReEnabled = klosReEnabledRaw && (oc.reEnabled ?? true)
        const klosVoEnabled = klosVoEnabledRaw && (oc.voEnabled ?? true)
        const klosAcEnabled = klosAcEnabledRaw && (oc.acEnabled ?? true)

        // Boeideel (fascia) geometry (mm)
        // - dz: fascia thickness in Z (depth of board)
        // - dsz: lijst (trim strip) thickness in Z
        // - lijstEnabled: whether lijst is present
        // - lijstPosition: true = lijst on the inside (no contribution to outside overhang)
        const dz = size.boeideel?.enabled ? (size.boeideel.z || 0) : 0
        const dsz = size.boeideel?.lijstEnabled ? (size.boeideel.lz || 0) : 0
        /* eslint-disable no-unused-vars */
        const lijstEnabled = !!size.boeideel?.lijstEnabled
        const lijstPosition = !!size.boeideel?.lijstPosition

        // Boeideel offsets (mm)
        // - dpok: kopkant offset (gable end)
        // - dpog: gootzijde offset (gutter side)
        const dpok = size.boeideel?.dpOffsetKopkant || 0
        const dpog = size.boeideel?.dpOffsetGootzijde || 0

        // Roof overhang (mm) – used for pitched roofs in 3D
        const roofOverhang = size.dak?.overhang || 0
        /* eslint-enable no-unused-vars */

        // Note: We don’t have a reliable isPlatdak flag here; 3D determines it by typeId.
        // For UI we keep the existing simplified calculation, but we expose all variables with comments above
        // so it’s easy to switch to the exact 3D formula later if needed.

        // Compute per-side klos contributions
        // For pitched roofs (Kapschuur/Zadeldak) the UI cannot truly disable overstek klossen;
        // therefore we ignore the UI toggles and only respect the raw availability flags from the size.
        // For other roofs (e.g., Plat dak) we keep current behavior and honor the UI toggles.
        const _roofNameLc = (roofTypeName || '').toLowerCase()
        const forceKlosByRoof = _roofNameLc.includes('kapschuur') || _roofNameLc.includes('zadeldak')


        // When forcing by roof: use raw flags; otherwise use UI-gated flags computed above
        const overstekKlosLinks = forceKlosByRoof ? xBovLi : klosLiEnabled ? xBovLi : 0
        const overstekKlosRechts = forceKlosByRoof ? xBovRe : klosReEnabled ? xBovRe : 0
        const overstekKlosVoor = forceKlosByRoof ? xBovVo : klosVoEnabled ? xBovVo : 0
        const overstekKlosAchter = forceKlosByRoof ? xBovAc : klosAcEnabled ? xBovAc : 0

        // Lijst (trim) only contributes when present and mounted on the outside
        // Match 3D rule: ((!lijstEnabled || lijstPosition) ? 0 : dsz)
        const boeideel = dz
        const lijstOutside = (lijstEnabled && !lijstPosition) ? dsz : 0



        const groupLabel = `${LOG_PREFIX} diepte=${size?.diepte ?? 'n/a'} breedte=${breedte?.breedte ?? 'n/a'} modelType=${modelType?.name ?? modelType?.label ?? modelType?.id ?? 'n/a'} roofType=${roofTypeName ?? roofTypeId ?? 'n/a'}`
        // console.groupCollapsed(groupLabel)
        // console.log(LOG_PREFIX, 'modelType', modelType)
        // console.log(LOG_PREFIX, 'roofType', { roofTypeId, roofTypeName })
        // console.log(LOG_PREFIX, '_roofNameLc', _roofNameLc)
        // console.log(LOG_PREFIX, 'forceKlosByRoof', forceKlosByRoof)
        // console.log(LOG_PREFIX, 'input', { sizeDiepte: size?.diepte, breedte: breedte?.breedte })
        // console.log(LOG_PREFIX, 'klos flags raw', { klosLiEnabledRaw, klosReEnabledRaw, klosVoEnabledRaw, klosAcEnabledRaw })
        // console.log(LOG_PREFIX, 'klos flags effective (with UI)', { klosLiEnabled, klosReEnabled, klosVoEnabled, klosAcEnabled })
        // console.log(LOG_PREFIX, 'klos lengths (xBov*)', { xBovLi, xBovRe, xBovVo, xBovAc })
        // console.log(LOG_PREFIX, 'klos override policy', { forceKlosByRoof, roofTypeName })
        // console.log(LOG_PREFIX, 'boeideel', { dz, dsz, lijstEnabled, lijstPosition })
        // console.log(LOG_PREFIX, 'offsets', { dpok, dpog })
        // console.log(LOG_PREFIX, 'roof', { roofOverhang })
        // console.log(LOG_PREFIX, 'klos contributions', { overstekKlosLinks, overstekKlosRechts, overstekKlosVoor, overstekKlosAchter })
        // console.log(LOG_PREFIX, 'boeideel+lijstOutside used', { boeideel, lijstOutside, lijstEnabled, lijstPosition })
        /* eslint-enable no-console */

        // Existing simplified UI calculation (kept to avoid changing current behavior):
        // total depth = frame depth + front/back klos + 2*(boeideel + lijst)
        // total width = frame width + left/right klos + 2*(boeideel + lijst)
        
        const totalDiepte = size.diepte + overstekKlosVoor + overstekKlosAchter + (boeideel + lijstOutside) * 2
        // eslint-disable-next-line no-console
        // console.log(
        //   `${LOG_PREFIX} totalDiepte berekening: ` +
        //   `diepte=${size.diepte} + ` +
        //   `overstekKlosVoor=${overstekKlosVoor} + ` +
        //   `overstekKlosAchter=${overstekKlosAchter} + ` +
        //   `(boeideel=${boeideel} + lijstOutside=${lijstOutside}) * 2 = ${totalDiepte}`
        // )
        let totalBreedte = null
        if (breedte) {
          totalBreedte = breedte.breedte + overstekKlosLinks + overstekKlosRechts + (boeideel + lijstOutside) * 2
          // eslint-disable-next-line no-console
          // console.log(
          //   `${LOG_PREFIX} totalBreedte berekening: ` +
          //   `breedte=${breedte.breedte} + ` +
          //   `overstekKlosLinks=${overstekKlosLinks} + ` +
          //   `overstekKlosRechts=${overstekKlosRechts} + ` +
          //   `(boeideel=${boeideel} + lijstOutside=${lijstOutside}) * 2 = ${totalBreedte}`
          // )
        }

        //     const totalOverhang = {
        //   a: veranda?.enabled
        //     ? veranda.dikte
        //     : this.modelType.isLissabon ? totalWidthAchter : (!this.isPlatdak?(absoluteWidth-z/2):((kl&&kr ? xBovAc : 0)+dz+((!lijstEnabled || lijstPosition)?0:dsz))),
        //   v: this.modelType.isLissabon ? Math.round(totalWidthVoor-this.snijpuntX) : (!this.isPlatdak?(absoluteWidth-z/2):(xBovVo+dz+((!lijstEnabled || lijstPosition)?0:dsz))),
        //   l: ((kl&&this.isPlatdak) ? xBovLi : 0)+dz+((!lijstEnabled || lijstPosition)?0:dsz) +(!this.isPlatdak?dak.overhang+dpok:0),
        //   r: ((kr&&this.isPlatdak) ? xBovRe : 0)+dz+((!lijstEnabled || lijstPosition)?0:dsz) +(!this.isPlatdak?dak.overhang+dpok:0)
        // }

        const totalOverhangA = boeideel

        // Return total dimensions including simplified overhangs
        /* eslint-disable no-console */
        // console.log(LOG_PREFIX, 'totals', { x: totalBreedte, y: totalDiepte })
        // console.groupEnd()
        /* eslint-enable no-console */
        return { x: totalBreedte, y: totalDiepte }
      },

      async getUISettings() {
        await this.$store.dispatch('getMenuUISettings')
      },
      specsBtnMouseOver() {
        this.hasGlowingInfoBtn = true;
      },
      specsBtnMouseLeave(){
        this.hasGlowingInfoBtn = false;
      },
      specsCloseBtnMouseOver() {
        this.hasGlowingCloseBtn = true;
      },
      specsCloseBtnMouseLeave(){
        this.hasGlowingCloseBtn = false;
      },
      enableAndHoldSpecs() {
        this.specsVisible = !this.specsVisible;
      }
    },

    computed: {
      ...mapGetters({
        models: 'getAvailableTypes',
        modelTypes: 'getModelTypes',
        config: 'getConfig',
        selectedSizes: 'getSelectedSizes',
        getSizes: 'getSizes',
        getBergingen: 'getBergingTypes',
        getSelectedSizeMode: 'getSelectedSizeMode',
        getMaatwerkWidth: 'getMaatwerkWidth',
        getMaatwerkDepth: 'getMaatwerkDepth',
        getOverstekConfig: 'getOverstekConfig',
        uiSettings: 'getMenuUISettings',
        infoboxes: 'getInfoboxes'
      }),
      maatwerkEnabled () {
        return this.config.maatwerk.enabled
      },
    },

    watch: {
      maatwerkEnabled (value) {
        if(!value) {
          this.selectedSizeMode = '0'
        }
      },
      getMaatwerkWidth (value) {
        this.width = value
      },
      getMaatwerkDepth (value) {
        this.depth = value
      },

      overstekConfig: {
        handler (value) {
          if (JSON.stringify(value) !== JSON.stringify(this.getOverstekConfig)) {
            this.$store.dispatch('overstekConfigChanged', JSON.parse(JSON.stringify(value)))
          }
        },
        deep: true
      }
    },

    mounted() {
      this.selectedSizeMode = this.getSelectedSizeMode
      this.width = this.getMaatwerkWidth
      this.depth = this.getMaatwerkDepth
      this.overstekConfig = JSON.parse(JSON.stringify(this.getOverstekConfig))
    },

    beforeDestroy() {
      this.$store.dispatch('setSelectedSizeMode', this.selectedSizeMode)
      this.$store.dispatch('setMaatwerkWidth', this.width)
      this.$store.dispatch('setMaatwerkDepth', this.depth)
    }
  }
</script>

<style lang="scss" scoped>

.sizes {
  display: flex;
  flex-direction: column;
  // gap: 25px;

  & p {
    text-align: left;
    margin-top: 4px;
  }

  &-section {
    display: flex;
    flex-direction: column;
    gap: 16px;
    
    // & h3 {
    //   text-align: left;
    //   font-size: 1.5rem;
    //   margin: 0px;
    // }

    &-title {
      background-color: $c-background-1;
      font-size: 1.2rem;
      margin: 0px;
      font-size: 19px;
      color: $c-primary;
      font-family: "Oswald", sans-serif;
      text-transform: uppercase;
      height: 48px;
      width: 100%;
      line-height: 48px;
      border-radius: $radius-m;
    }
  }
}

.sizes-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;

  @media (max-width: 999px) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }

  &-size {
    cursor: pointer;
    display: flex;
    border-radius: $radius-m;
    border: none !important;
    padding: 1px;
    box-sizing: border-box;
    transition: background-color 100ms ease, color 100ms ease, border 100ms ease;
    width: 184px;
    height: 48px;
    background-color: $c-primary;

    @media (max-width: 999px) {
      width: 100%;
    }
  
    & div {
      background-color: white;
      width: 100%;
      height: 100%;
      border-radius: $radius-m - 1px;
      display: flex;
      align-items: center;
      flex-direction: column;
    }

    .staander {
      font-size: 10px;
      font-family: inherit;;
    }

    &-active {
      & div {
        background-color: transparent !important;
      }
    }
    
    & p {
      margin: 0px;
      font-weight: 600;
      font-size: 19px;
      font-family: "Oswald", sans-serif;
      color: $c-primary;
    }

    &:hover {
      background-color: $c-background-1;
    }
    
    &-active {
      border: 2px solid $c-primary;
      background-color: $c-primary;
      color: $c-secondary-bright;//$c-secondary;

      &:hover {
        background-color: $c-primary;
      }

      & p {
        color: $c-secondary;
      }
    }
  }
}

.diepte-breedte-container {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 16px;
}

.custom-size-input-container {
  display: flex;
  gap: 12px;
  width: 100%;
  align-items: center;
}

.custom-size {
  &-title {
    display: flex;
    justify-content: end;
    flex: 1;    text-transform: uppercase;
    font-family: 'Oswald', sans-serif;
    font-weight: 700;
    font-size:19px;
    color: $c-primary;

    &-range {
      font-family: 'Oswald', sans-serif;
      font-weight: 400;
      font-size:19px;
      color: $c-primary;
    }
  }

  &-input {
    margin:0;
    width: 320px;
    height: 48px;
    box-sizing: border-box;
    border: 2px solid $c-border-1;
    border-radius: $radius-m;
    padding: 8px;
    font-family: 'Oswald', sans-serif;
    font-weight: 700;
    font-size: 19px;
    color: $c-primary;

    &-unit {
      font-family: 'Oswald', sans-serif;
      font-weight: 700;
      font-size:19px;
      color: $c-primary;
      text-transform: uppercase;
    }

    &-after {
      background-color: $c-border-1; 
      border-radius: $radius-m;
      display: flex;
      gap:4px;
      align-items: center;
      justify-content: center;

      width: 160px;
      height: 48px;
    }
  }
}

.afmetingen-text {
  font-size: 15px;
}

.afmetingen-image {
  padding: 8px 16px 0px 0px;
  box-sizing: border-box;
  width: 100%;
}

// .custom-size-input {
//   width: 96%;
//   border: none;
//   border-radius: $radius-m;
//   font-size: 1rem;
//   margin-top: 4px;
//   margin-bottom: 14px;
//   border-radius: $radius-s;
//   font-weight: 500;
//   outline: 2px solid $c-border-1;
//   transition: outline 100ms ease;
//   line-height: 28px;
//   padding: 6px 12px;
// }

// .custom-size-input:hover {
//   outline: 2px solid $c-secondary;
// }

// .custom-size-title {
//   flex:2;
// }

// .custom-size-input-container {
//   position: relative;
//   display: flex;
//   flex: 1 5 1;

//   & .number {
//     flex:5;
//   }
// }

// .custom-size-input-after {
//   position: absolute;
//   right: -2px;
//   top: 4px;
// }

// .custom-size-input-unit {
//   display: inline-block;
//   border-radius: 0px $radius-s $radius-s 0px;
//   background-color: $c-background-1;
//   line-height: 28px;
//   padding: 6px 12px;
// }

// .custom-size-input:focus {
//   border: none;
//   outline: 3px solid $c-secondary;
// }

// .custom-size-title {
//   font-size: 1.2rem;
//   text-align: left;
// }

// .custom-size-title-range {
//   color: #53565a;
//   margin: 0px;
//   padding: 0px;
//   margin-top: 5px;
//   display: inline-block;
//   margin-right: 4px;
//   vertical-align: bottom;
//   font-size: 15px
// }

.standaardmaten {
  display: flex;
  flex-direction: column;
  gap: 15px;

  &-text {
    margin:0;
    padding: 8px 8px 0px 8px;
  }
}

.overstek-header {
  justify-content: space-between;
}

.overstek-text {
  font-size: 20px;
  margin-bottom: 8px;
}

.overstekklos-container {
  margin-top: 16px;
  &-block {
    text-align: left;
    margin-bottom: 6px;
  }
  &-label {
    font-family: inherit;
    text-transform: lowercase;
    font-weight: 500;
    color: black;
    display: inline-block;
    margin-left: 8px;
  }
  &-checkbox {
    display: inline-block;
    width: 20px;
    height: 20px;
  }
}

.expand-header {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 10px;
  border-bottom: 2px solid $c-border-1;

  & h3 {
    margin: 0px;
    font-size: 1.5rem;
  }

  &-margin {
    margin-top: 20px;
  }
}

.overstek-header {
  display: flex;
}

.card {
  &-button-specs {
    cursor: pointer;
    display: flex;
    align-items: center;
    flex-direction: row;
    // position: absolute;
    margin-top: 4px;
    height: 23px;
    right: 0;
    padding: 3px;
    border-radius: $radius-l;
    border-style: none;
    background-color: $c-secondary; // babc16
    color: white; //$c-secondary-text;

    &-text {
      font-size: 0.8rem;
      padding: 0px 8px;
      padding-right: 16px;
      font-family: 'Source Sans 3', sans-serif;
    }
  }

  &-question-mark {
    // padding: 5px 10px;
    padding: 0px 5px;
    border-radius: $radius-l;
    font-weight: bold;
    font-size: 0.7rem;    
    color: white;
    background-color: $c-primary;
  }
}


#fullcover {
  position: fixed;
  z-index: 998;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
}
.modalspecs {
  position: fixed;
  z-index: 999;
  // top: 10%;
  left: 50%;
  // width: 30rem;
  // margin-left: -15rem;
  // height: 80vh;
  background-color: white;
  border-radius: $radius-s;
}
.modalspecs-size {
    top: 3%;
    width: 36rem;
    margin-left: -18rem;
    height: 94vh;
 }
.modalspecs-size-mobile {
    top: 10%;
    width: 98%;
    margin-left: -49%;
    height: 80vh;
 }

.modaltopcontainer {
  display: flex; text-align: start; height: 8vh
}
.modaltopcontainer h3 {
  margin: 1.5vh 1.5vh 1.5vh 3vh;
}
// .greyheader {
//   color: $c-secondary;
//   background-color: $c-primary; 
//   border-radius: 5px; 
//   margin: 0px 10px 10px 10px; 
//   font-size: x-large;
//   text-align: center; 
// }

.imagescroller {
  // max-height: calc(85% - 1px); // a trick to force a scroll area to appear despite fixed position
  max-height: calc(98%); // minus size of modaltopcontainer
  overflow-y: auto;
  border-radius: $radius-m;
}
.modalimage {
  width: 100%;
  height: auto;
}

.modalclosebutton {
  position: absolute;
  // margin-left: auto;
  top: 32px;
  right: 48px;
  height: 4vh;
  width: 4vh;
  background: transparent;
  color: white;
  border: 2px solid white;
  box-sizing: border-box;
  border-radius: 3vh;
  // padding: 0px 10px 0px 10px;
  font-size: 4vh;
  pointer-events: all;
  cursor: pointer;
  // force the × to stay centered despite resizing
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.5s ease;

  &:hover {
    background-color: rgba(255, 255, 15, 0.75);
  }
}

</style>

<style lang="scss">
.overstekklos-container-checkbox > span > svg {
  margin-top: -6px;
  margin-left: -1px;
}
</style>